import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { routes } from "./routes";

/**
 * Root application component.
 *
 * Renders the route tree. All route-level code splitting is handled in routes/index.tsx.
 * This component stays minimal — layout, auth guards, and providers are in the route tree.
 */
export default function App() {
  const element = useRoutes(routes);
  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center bg-neutral-50">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-neutral-200 border-t-primary-600" />
        </div>
      }
    >
      {element}
    </Suspense>
  );
}
